import { CircularProgress } from "@material-ui/core";
import React from "react";
import useStyles from "./style";

export default function PageLoader() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <CircularProgress color="secondary" />
        </div>
    );
}
